<style lang="scss" scoped>
</style>

<template>
  <iframe
    src="https://www.hilton.com.cn/global_footer/header.html"
    width="100%"
    height="50px"
    frameborder="no"
  ></iframe>
</template>

<script>
export default {
  props: {},
  components: {},
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

